import { Select } from '@creditornot/cb-select';
import React, { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { Typography } from 'common/typography';

import { OperationsChartCategory } from './types';

type OperationsChartSelectorProps = {
  selectedCategory: OperationsChartCategory;
  setSelectedCategory: (value: OperationsChartCategory) => void;
  unavailableCategories?: OperationsChartCategory[];
};
const ChartSelector = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  margin-block: 24px;
  padding-inline: 16px;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding-inline: 12px;
  }
`;

const SelectWrapper = styled.div`
  min-width: 208px;
`;

const OperationsChartSelector = ({
  selectedCategory,
  setSelectedCategory,
  unavailableCategories,
}: OperationsChartSelectorProps) => {
  const { formatMessage } = useIntl();
  const chartOptions = useMemo(
    () =>
      [
        {
          label: formatMessage({ id: 'insights.sales-by-venue.rejections' }),
          value: OperationsChartCategory.REJECTIONS,
        },
        { label: formatMessage({ id: 'insights.punctuality.title' }), value: OperationsChartCategory.PUNCTUALITY },
        {
          label: formatMessage({ id: 'insights.operations.preparation-time' }),
          value: OperationsChartCategory.PREPARATION_TIME,
        },
      ].filter(option => !unavailableCategories?.includes(option.value)),
    [formatMessage, unavailableCategories],
  );
  return (
    <ChartSelector>
      <Typography.Body3>
        <FormattedMessage id="insights.performance.show-chart-for" />
      </Typography.Body3>
      <SelectWrapper>
        <Select
          value={selectedCategory}
          options={chartOptions}
          onChange={(value: OperationsChartCategory) => setSelectedCategory(value)}
          disableSearch
        />
      </SelectWrapper>
    </ChartSelector>
  );
};

export default OperationsChartSelector;
